import { render, staticRenderFns } from "./TestSendModal.vue?vue&type=template&id=28fa75f8&"
import script from "./TestSendModal.vue?vue&type=script&lang=js&"
export * from "./TestSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports